import React from 'react'
import { getImgUrl, i18n } from '../../../../common/util'
import { AppContext } from '../../../../config/context'

class HmHot extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            list: window._inject_app_data_.recommend,
            style: {},
            itemStyle: { width: '1368px' },
            index: -1
        }
    }

    focus = index => {
        this.setState({
            style: {
                left: index === 0 ? '0' : `-${index * 276}px`
            },
            index
        })
    }

    blur = () => {
        this.setState({
            style: {},
            index: -1
        })
    }

    render() {
        const { list, style, itemStyle, index } = this.state
        const { lang } = this.context.user
        return <div className="homemade-hot-container">
            <div className="homemade-hot-window">
                <ul className="homemade-hot-wrapper" style={style}>
                    {
                        list.map((item, i) => (<a target={item.target} href={item.url} key={item.goodsId} st-btn="1" st-category="橱窗" st-label="热游推荐"
                            st-action="click" st-value={JSON.stringify([{ goodsId: item.goodsId, goodsName: item.name }])} st-element-id={`homemade-hot-${i}`}>
                            <li className="homemade-hot-item" style={index === i ? itemStyle : {}} onMouseEnter={() => this.focus(i)} onMouseLeave={this.blur}>

                                <img alt="" className="homemade-hot-img" src={getImgUrl(item.goodsPic)}></img>
                                <p className="homemade-hot-name">{i18n(item.name, lang)}</p>
                                <img alt="" className="homemade-hot-banner" src={getImgUrl(item.imgUrl)}></img>
                            </li>
                        </a>))
                    }
                </ul>
            </div>
        </div>
    }
}

HmHot.contextType = AppContext
export default HmHot